module.exports = __webpack_public_path__ + "static/img/register.e76cd9f5.png";